import React from 'react';
import { connect } from "react-redux";
import './DlUnitLi.scss';
import { getUnitLiPage } from "./../../actions";
import { dlUnitPageCountGet } from '../../selectors';

const mapStateToProps = (state) => ({
  dlUnitMaxPerPage: state.dlUnitLi.dlUnitMaxPerPage, 
  dlUnitCount: state.dlUnitLi.dlUnitCount, 
  dlUnitPage: state.dlUnitLi.dlUnitPage
});

const mapDispatchToProps = (dispatch) => ({
  getUnitLiPage: (payload) => dispatch(getUnitLiPage(payload))
});

const DlUnitLiNav = ({ dlUnitMaxPerPage, dlUnitCount, dlUnitPage, getUnitLiPage }) => {
  const pageCount = dlUnitPageCountGet({ dlUnitLi: { dlUnitMaxPerPage, dlUnitCount } });

  const liNav = (pageNum) => {
    if (pageNum>=1 && pageNum<=pageCount) {
      getUnitLiPage(pageNum);
    }
  };

  const nav = ((dlUnitCount > dlUnitMaxPerPage && dlUnitPage >= 1 ) ?
    (
      <div className="nav">
        <span onClick={ () => liNav(1) }>&lt;&lt;</span>
        <span onClick={ () => liNav(dlUnitPage - 1) }>&lt;</span>
        <span onClick={ () => liNav(dlUnitPage + 1) }>&gt;</span>
        <span onClick={ () => liNav(pageCount) }>&gt;&gt;</span>
        <span style={{ marginLeft: '2%' }}>{dlUnitPage}</span>
        <span style={{ marginLeft: '0.5%' }}>/</span>
        <span style={{ marginLeft: '0.5%' }}>{pageCount}</span>
      </div>
    )
    : null);

  return nav;

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitLiNav);
